import React from 'react'

export default function Popular() {
  return (
    <div className='popular'>
         <h4>Popular Recipes</h4>
        <div className="flex">
            <div className='card'><img src="https://minimalistbaker.com/wp-content/uploads/2023/02/Peanut-Butter-Cookie-Granola-8-500x750.jpg" alt="" />
            <h5>Peanut Butter Cookie Granola (Naturally Sweetened)</h5></div>
            <div className='card'><img src="https://minimalistbaker.com/wp-content/uploads/2023/03/Vegan-Peanut-Butter-Frosting-9-500x750.jpg" alt="" />
            <h5>Fluffy Vegan Peanut Butter Frosting</h5></div>
            <div className='card'><img src="https://minimalistbaker.com/wp-content/uploads/2019/03/PERFECT-Vegan-Buttercream-Frosting-EVERY-TIME-3-ingredients-10-minutes-FLUFFY-perfectly-sweet-vegan-buttercream-glutenfree-minimalistbaker-recipe-8-600x900.jpg" alt="" />
            <h5>Vegan Frosting Recipes</h5></div>
            <div className='card'><img src="https://minimalistbaker.com/wp-content/uploads/2018/08/AMAZING-Raw-Vegan-Carrot-Cake-10-ingredients-simple-methods-naturally-sweetened-topped-with-vegan-cream-cheese-frosting-raw-dessert-carrotcake-vegan-glutenfree-minimalistbaker-73-600x900.jpg" alt="" />
            <h5>Chocolate Avocado Frosting (Vegan, No Powdered Sugar!)</h5></div>

      
    </div>
    <div className="flex">
            <div className='card'><img src="https://minimalistbaker.com/wp-content/uploads/2023/03/Baked-Strawberry-Donuts-Vegan-Gluten-Free-15-500x750.jpg" alt="" />
            <h5>Easy Baked Strawberry Donuts (Vegan + GF)</h5></div>
            <div className='card'><img src="https://minimalistbaker.com/wp-content/uploads/2023/02/Homemade-Vegan-Peanut-Butter-Eggs-7-500x750.jpg" alt="" />
            <h5>Easy Vegan Peanut Butter Eggs (Reese’s Dupe!)</h5></div>
            <div className='card'><img src="https://minimalistbaker.com/wp-content/uploads/2023/02/Vegan-Gluten-Free-Nutter-Butters-5.jpg" alt="" />
            <h5>Gluten-Free Nutter Butters (Vegan)</h5></div>
        </div>    <div>
        <button>More +</button></div>
    </div>
  )
}
